import { useEffect, useState } from 'react';

import checkExtensionInstalled from 'Helpers/Extension/CheckExtensionInstalled';

const useExtensionInstalled = () => {
  const [oldExtensionInstalled, setOldExtensionInstalled] = useState(null);
  const [extensionInstalled, setExtensionInstalled] = useState(null);

  useEffect(() => {
    // V3
    checkExtensionInstalled(true)
      .then(() => setExtensionInstalled(true))
      .catch(() => setExtensionInstalled(false));

    // V1 / Assistant
    checkExtensionInstalled(null, true)
      .then(() => setOldExtensionInstalled(true))
      .catch(() => setOldExtensionInstalled(false));
  }, []);
  return { extensionInstalled, oldExtensionInstalled };
};

export default useExtensionInstalled;
